import { ISingleDeviceIssueHistory } from "../DTOs";
import { AlertUnion } from "../Models";

export interface FaultHistoryRecords {
  alerts: AlertUnion[];
  issues: ISingleDeviceIssueHistory[];
}

function mergeRecords<T extends { startTime: number }>(
  previous: T[],
  next: T[],
  key: (record: T) => string
): T[] {
  const unique = new Map(previous.map((record) => [key(record), record]));
  next.forEach((record) => unique.set(key(record), record));
  // BFF dates are ISO strings at runtime; Date also accepts existing numeric timestamps.
  return [...unique.values()].sort(
    (a, b) => new Date(b.startTime).getTime() - new Date(a.startTime).getTime()
  );
}

export function mergeHistory(
  previous: FaultHistoryRecords,
  next: FaultHistoryRecords
): FaultHistoryRecords {
  return {
    alerts: mergeRecords(
      previous.alerts,
      next.alerts,
      (alert) => `${alert.kind}:${alert.alertType}:${alert.id}`
    ),
    issues: mergeRecords(previous.issues, next.issues, (issue) => `${issue.issueType}:${issue.id}`),
  };
}
